import { render, staticRenderFns } from "./PasswordRequest.vue?vue&type=template&id=03f4c79e&"
import script from "./PasswordRequest.vue?vue&type=script&lang=js&"
export * from "./PasswordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports